module.exports = __webpack_public_path__ + "img/login-bg.5afa4895.png";